"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const buffer_1 = require("buffer");
const PublicKey_1 = __importDefault(require("./PublicKey"));
const EDDSA = require("./ed25519e");
const eddsa = new EDDSA();
class PrivateKey {
    constructor(privKey) {
        this.privKey = privKey;
    }
    toBytes() {
        return this.privKey;
    }
    toPublicKey() {
        const keyPair = eddsa.keyFromSecret(this.privKey);
        return new PublicKey_1.default(buffer_1.Buffer.from(keyPair.pubBytes()));
    }
    sign(data) {
        const keyPair = eddsa.keyFromSecret(this.privKey);
        const signature = keyPair.sign(data.toString("hex"));
        return buffer_1.Buffer.from(signature.toBytes());
    }
    verify(signature, message) {
        const keyPair = eddsa.keyFromSecret(this.privKey);
        return keyPair.verify(message.toString("hex"), signature.toString("hex"));
    }
}
exports.default = PrivateKey;
